/**
 * 各产线 Stripe Price ID 配置表
 * 按产线 → 计费周期 → 环境 分组，方便统一查找和更新
 *
 * 环境说明：
 *   stage — 测试环境
 *   cn    — 中国区生产
 *   us    — 美国区生产
 *   eu    — 欧洲区生产
 */
export const STRIPE_PRICE_IDS = {
    /** RD 产线（stage 与 cn 共用同一套 ID） */
    rd: {
        pro_monthly: {
            stage: 'price_1SzTRt4BHjfY2tko9hRTn6lm',
            cn: '',
            us: 'price_1TBVWv3n4XHnBaSm1uMi3KHJ',
            eu: 'price_1T9KeB3n4XHnBaSmdjvsMuED',
        },
        pro_yearly: {
            stage: 'price_1SzTSA4BHjfY2tkodoZEejax',
            cn: '',
            us: 'price_1SzTsn3n4XHnBaSmadDrjQtL',
            eu: 'price_1T9KeW3n4XHnBaSm6iE26PEd',
        },
    },

    /** MSE 产线（cn 暂未上线，留空） */
    mse: {
        pro_monthly: {
            stage: 'price_1T9i1Q4BHjfY2tkoYsZBydxB',
            cn: '',
            us: 'price_1T9hlw3n4XHnBaSmV54ChgKh',
            eu: 'price_1T9i3o3n4XHnBaSmf6VRH8nY',
        },
        pro_yearly: {
            stage: 'price_1T9i1r4BHjfY2tkoFpaBtbIk',
            cn: '',
            us: 'price_1T9hmv3n4XHnBaSmZpvpwwdS',
            eu: 'price_1T9i433n4XHnBaSmLnlDej1x',
        },
    },

    /** IP 产线（cn 暂未上线，留空） */
    ip_searching: {
        pro_monthly: {
            stage: 'price_1Sq8Ov4BHjfY2tkoKvb8C8U6',
            cn: '',
            us: 'price_1T7uQM3n4XHnBaSmnOVDAB8x',
            eu: 'price_1TALIF3n4XHnBaSmOD7MlYoF',
        },
        pro_yearly: {
            stage: 'price_1Sq8Ou4BHjfY2tkoFVUUF5ep',
            cn: '',
            us: 'price_1T7uQM3n4XHnBaSmLJTBa80T',
            eu: 'price_1TALIn3n4XHnBaSmMuPOcqvU',
        },
    },

    ip_drafting: {
        pro_monthly: {
            stage: 'price_1Sq5ti4BHjfY2tkozO0r3OSc',
            cn: '',
            us: 'price_1T6RW63n4XHnBaSmNNzpuL2m',
            eu: 'price_1TAOl83n4XHnBaSmq8ZcxP0B',
        },
        pro_yearly: {
            stage: 'price_1Sq5uh4BHjfY2tkoqAgXVClV',
            cn: '',
            us: 'price_1T9KtY3n4XHnBaSmw4s1CnfZ',
            eu: 'price_1TAOlR3n4XHnBaSmS4Uou47s',
        },
    },

    /** LS 产线（cn 暂未上线，留空） */
    ls_economy: {
        pro_monthly: {
            stage: 'price_1TZm054BHjfY2tkoh1Wy3AdT',
            cn: '',
            us: 'price_1TZlpM3n4XHnBaSm1YQDaUSp',
            eu: 'price_1TZlyJ3n4XHnBaSmiVLTWamg',
        },
        pro_yearly: {
            stage: 'price_1TZm0P4BHjfY2tkoTMgg0bPl',
            cn: '',
            us: 'price_1TZlqP3n4XHnBaSmtoeOZCDA',
            eu: 'price_1TZlyb3n4XHnBaSmHmH5SpqD',
        },
    },
    ls_standard: {
        pro_monthly: {
            stage: 'price_1SzY7R4BHjfY2tkoL0NlzKbm',
            cn: '',
            us: 'price_1T7otA3n4XHnBaSm6MQ8LLJ8',
            eu: 'price_1TBVLF3n4XHnBaSmoMAX62we',
        },
        pro_yearly: {
            stage: 'price_1SzYTl4BHjfY2tkorTPuPatb',
            cn: '',
            us: 'price_1T7otX3n4XHnBaSmZNmAXrl9',
            eu: 'price_1TBVLe3n4XHnBaSmaq8V4ivJ',
        },
    },
} as const;
